import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import './AddPurchase.css';
import axios from "axios";

const EditSalarySF = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { salary_id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    salary_id: "",
    name: "",
    desig_name: "",
    date_of_join: "",
    actual: "",
    total_days: "",
    lop: "",
    working_days: "",
    hra_per: "",
    epf_per: "",
    savings_per: "",
    iste_per: "",
    gross: "",
    basic: "",
    hra_amt: "",
    iste_amt: "",
    epf_amt: "",
    savings_amt: "",
    others: "",
    deduction: "",
    net_salary: "",
  });

  useEffect(() => {
    console.log("Editing salary record ID:", salary_id);
    // TODO: Fetch salary data by ID from backend
  }, [salary_id]);

  useEffect(() => {
      axios.post(`${API_BASE_URL}salary_sf_detail.php`,{salary_id:salary_id})
        .then((response) => {
          if (response.data.head.code === 200 ) {
            setFormData(response.data.body);
            // setFilteredOrders(response.data.body);
            // console.log(response.data.body[0]);
  
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
            setFormData([]);
            // setFilteredOrders([]);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
          setFormData([]);
          // setFilteredOrders([]);
        }).finally(() => {
          // setLoading(false); // Set loading to false after API call
        });
    }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Updated SalarySF Record:", formData);
    // TODO: Submit updated data to 
    
    axios.post(`${API_BASE_URL}salary_sf_detail_edit.php`, formData)
        .then((response) => {
          if (response.data.head.code === 200) {
            // setDepartmentList(response.data.body);
            // setFilteredOrders(response.data.body);
            window.history.back();
            // navigate("/salarysf");

          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
            // setDepartmentList([]);
            // setFilteredOrders([]);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
          // setDepartmentList([]);
          // setFilteredOrders([]);
        }).finally(() => {
          // setLoading(false); // Set loading to false after API call
        });
    
  };

  useEffect(() => {
      setFormData((prev) => {
        const actual = Number(prev.actual) || 0;
        const totalDays = Number(prev.total_days) || 1;
        const lop = Number(prev.lop) || 0;
  
        // Gross = actual – (lop * perDaySalary)
        const perDay = actual / totalDays;
        const lopAmt = perDay * lop;
        const gross = actual - lopAmt;
  
        // HRA
        const hra_per = Number(prev.hra_per) || 0;
        const hra_amt = (gross * hra_per) / 100;
  
        // Basic = Gross – HRA
        const basic = gross - hra_amt;
  
        // Savings
        const savings_per = Number(prev.savings_per) || 0;
        const savings_amt = (basic * savings_per) / 100;
  
        // EPF
        const epf_per = Number(prev.epf_per) || 0;
        const epf_amt = (basic * epf_per) / 100;
  
        // ISTE
        const iste_per = Number(prev.iste_per) || 0;
        const iste_amt = (actual * iste_per) / 100;
  
        const others = Number(prev.others) || 0;
  
        // Total Deduction
        const totalDeduction = savings_amt + epf_amt;
  
        // Net Salary
        const netSalary = gross - totalDeduction;
  
        return {
          ...prev,
          gross: gross.toFixed(2),
          hra_amt: hra_amt.toFixed(2),
          basic: basic.toFixed(2),
          savings_amt: savings_amt.toFixed(2),
          epf_amt: epf_amt.toFixed(2),
          iste_amt: iste_amt.toFixed(2),
          others: others.toFixed(2),
          deduction: totalDeduction.toFixed(2),
          net_salary: netSalary.toFixed(2),
        };
      });
    }, [
      formData.actual,
      formData.total_days,
      formData.lop,
      formData.hra_per,
      formData.savings_per,
      formData.epf_per,
      formData.iste_per,
      formData.others
    ]);

  return (
    <Container className="my-4">
      <div className="form-header mb-4">
        <h4 className="mb-0">Edit Salary Details</h4>
        <button className="btn-top" onClick={() => navigate(-1)}>Back</button>
      </div>

      <Form onSubmit={handleSubmit}>
        <Row className="g-3">
          {/* Personal Info */}
          {/* <Col lg={3} md={6}>
            <Form.Group>
              <Form.Label>ID</Form.Label>
              <Form.Control
                type="text"
                name="salary_id"
                value={formData.salary_id}
                onChange={handleChange}
                disabled
              />
            </Form.Group>
          </Col> */}

          <Col lg={3} md={6}>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                readOnly
              />
            </Form.Group>
          </Col>

          <Col lg={3} md={6}>
            <Form.Group>
              <Form.Label>Designation</Form.Label>
              <Form.Control
                type="text"
                name="desig_name"
                value={formData.desig_name}
                onChange={handleChange}
                readOnly
              />
            </Form.Group>
          </Col>

          <Col lg={3} md={6}>
            <Form.Group>
              <Form.Label>Date of Joining</Form.Label>
              <Form.Control
                type="date"
                name="date_of_join"
                value={formData.date_of_join}
                onChange={handleChange}
                readOnly
              />
            </Form.Group>
          </Col>

          {/* Attendance */}
          {["actual", "total_days", "lop", "working_days"].map((field) => (
            <Col lg={3} md={6} key={field}>
              <Form.Group>
                <Form.Label>{field.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())}</Form.Label>
                <Form.Control
                  type="number"
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  readOnly
                />
              </Form.Group>
            </Col>
          ))}

          {/* Percentages */}
          {["hra_per", "epf_per", "savings_per", "iste_per"].map((field) => (
            <Col lg={3} md={6} key={field}>
              <Form.Group>
                <Form.Label>{field.replace(/_/g, " ").toUpperCase()}</Form.Label>
                <Form.Control
                  type="number"
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          ))}

          {/* Salary Breakdown */}
          {["gross", "basic", "hra_amt", "iste_amt", "epf_amt", "savings_amt"].map((field) => (
            <Col lg={3} md={6} key={field}>
              <Form.Group>
                <Form.Label>{field.toUpperCase()}</Form.Label>
                <Form.Control
                  type="number"
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  readOnly
                />
              </Form.Group>
            </Col>
          ))}

          <Col lg={3} md={12}>
            <Form.Group>
              <Form.Label>Others</Form.Label>
              <Form.Control
                type="number"
                name="others"
                value={formData.others}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          {/* Final Calculations */}
          <Col lg={3} md={12}>
            <Form.Group>
              <Form.Label>Total Deduction</Form.Label>
              <Form.Control
                type="number"
                name="deduction"
                value={formData.deduction}
                onChange={handleChange}
                readOnly
              />
            </Form.Group>
          </Col>

          <Col lg={3} md={12}>
            <Form.Group>
              <Form.Label>Net Salary</Form.Label>
              <Form.Control
                type="number"
                name="net_salary"
                value={formData.net_salary}
                onChange={handleChange}
                readOnly
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="form-actions mt-4 d-flex justify-content-end gap-2">
          <Button type="submit" className="btn-submit">Update</Button>
          <Button type="button" className="btn-cancel" onClick={() => navigate(-1)}>Cancel</Button>
        </div>
      </Form>
    </Container>
  );
};

export default EditSalarySF;
